import { any, async, fromJSX, loadingAsyncState, nothing } from "widgets-for-react";
import { fetchEvents } from "../../../backendApi/EventsApi";
import { previousOrDefault, previousOrNull } from "../../../utils/asyncState";
import { buildUrlWithParams, parseParamsFromUrl } from "../../../utils/browserQueryParams";
import { diffObjectValues, naiveEqual } from "../../../utils/object";
import { useEffect } from "../../../utils/useEffect";
import { emptyJumbo } from "../../Jumbo/Jumbo";
import { EventOverview } from "./EventOverviewLayout/EventOverview";
import { activityHeaderId } from "./EventOverviewLayout/EventOverviewResult";
import { emptyFilterOptions, emptyFilters, filterTypeTemplate } from "./EventOverviewState";
export const loadEvents = (filterSettings, events)=>loadingAsyncState(fetchEvents(filterSettings), previousOrNull(events));
const searchParams = (params)=>{
    const diff = diffObjectValues(params, emptyFilters);
    const url = buildUrlWithParams(diff);
    return url.search;
};
export const EventOverviewWidget = (props)=>{
    const filterSettings = parseParamsFromUrl(emptyFilters, filterTypeTemplate);
    const shouldUpdate = props.events.kind == 'unloaded' || props.events.kind == 'loaded' && !naiveEqual(props.filterSettings, filterSettings);
    const updateParams = function(newSettings) {
        let addHistoryEntry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        const historyMethod = addHistoryEntry ? props.history.push : props.history.replace;
        const updatedFilterSettings = {
            ...filterSettings,
            ...newSettings
        };
        historyMethod(`${props.route}${searchParams(updatedFilterSettings)}`);
    };
    return any({
        key: 'EventOverview'
    })([
        // Render Layout
        fromJSX((setState)=>{
            return EventOverview({
                ...props,
                filterSettings,
                jumboProps: previousOrDefault(props.jumboContent, emptyJumbo),
                filterOptions: previousOrDefault(props.filterOptions, emptyFilterOptions),
                filterUpdaters: {
                    updatePage: (page)=>updateParams({
                            page
                        }),
                    updatePageSize: (pageSize)=>updateParams({
                            pageSize,
                            page: 1
                        }),
                    updateTags: (tags)=>updateParams({
                            tags,
                            page: 1
                        }),
                    updateRegions: (regions)=>updateParams({
                            regions,
                            page: 1
                        }),
                    updateLocations: (locations)=>updateParams({
                            locations,
                            page: 1
                        }),
                    updateQuery: (query)=>updateParams({
                            query
                        }, true),
                    updateDateRange: (from, to)=>updateParams({
                            from,
                            to,
                            page: 1
                        }),
                    toggleFilterVisibility: ()=>setState((s0)=>({
                                ...s0,
                                filterExpanded: !s0.filterExpanded
                            })),
                    resetFilter: ()=>updateParams(emptyFilters, true)
                }
            });
        }),
        // When filter params change, update the async search response
        useEffect((setState)=>shouldUpdate ? setState((s0)=>({
                    ...s0,
                    filterSettings,
                    events: loadEvents(filterSettings, s0.events)
                })) : undefined, [
            filterSettings
        ], {
            key: 'EventSearchUpdater'
        }),
        // Manage async state updates
        async(nothing, {
            key: 'eventsLoader'
        })(props.events).map((resultUpdater)=>(s0)=>{
                const events = resultUpdater(s0.events);
                if (!s0.filterExpanded && events.kind == 'loaded') {
                    setTimeout(scrollToResultIfOutOfView(activityHeaderId), 10);
                }
                return {
                    ...s0,
                    events
                };
            }),
        async(nothing, {
            key: 'jumboLoader'
        })(props.jumboContent).map((resultUpdater)=>(s0)=>{
                const jumboContent = resultUpdater(s0.jumboContent);
                return {
                    ...s0,
                    jumboContent
                };
            }),
        async(nothing, {
            key: 'filtersLoader'
        })(props.filterOptions).map((resultUpdater)=>(s0)=>{
                const filterOptions = resultUpdater(s0.filterOptions);
                return {
                    ...s0,
                    filterOptions
                };
            })
    ]);
};
const scrollToResultIfOutOfView = (targetId)=>{
    return ()=>{
        const element = document.getElementById(targetId);
        if (!element) return;
        const rect = element.getBoundingClientRect();
        if (rect.top < 0 || rect.bottom > window.innerHeight) {
            element.scrollIntoView({
                behavior: "smooth"
            });
        }
    };
};
